import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../../base/constant";

export const eventCustomerApi = createApi({
    reducerPath: "eventCustomerApi",
    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
        prepareHeaders: (headers: any) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("Authorization", `Token ${token}`);
            }
            return headers;
        }
    }),
    tagTypes: ['customerEvent'],
    endpoints: (builder) => ({
        getActiveEvents: builder.query<any, void>({
            query: () => ({
                url: "/customer-events/active/",
                method: "GET",
            }),
            providesTags: ['customerEvent']
        }),
        getActiveAds: builder.query<any, void>({
            query: () => ({
                url: "/customer-events/ads/",
                method: "GET",
            }),
            providesTags: ['customerEvent']
        }),
    }),
});

export const { useGetActiveEventsQuery, useGetActiveAdsQuery } = eventCustomerApi;
